import React, { useEffect, useState } from 'react';
import { ModelDefinitionDto } from '../../models/APIModels';
import { Grid, Typography, Button } from '@mui/material';
import ReactQuill from 'react-quill';

interface Iprops {
  model: ModelDefinitionDto;
  openClaimModal: () => void;
  getGridStyle: (method: string) => void;
}
const DetailsSection = ({ model, openClaimModal, editEnabled, getGridStyle }) => {
  const [matrics, setMatrics] = useState({});
  useEffect(() => {
    setMatrics(model.performanceStats?.metrics);
  }, [model]);
  return (
    <>
      <Grid item xs={12} sm={8} style={getGridStyle('left')} sx={{ paddingLeft: '0 !important', paddingRight: '10px' }}>
        <ReactQuill
          style={{ padding: '0px !important' }}
          value={model.modelLongDescriptionValue ?? ''}
          readOnly={true}
          theme={'bubble'}
        />
      </Grid>
      <Grid item xs={12} sm={4} style={getGridStyle('right')}>
        {matrics &&
          Object.keys(matrics).map((key, index) => {
            return (
              <>
                {matrics[key] > 0 && (
                  <Typography key={key} sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                    {key} : {matrics[key]}
                  </Typography>
                )}
              </>
            );
          })}

        {
          <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
            Total Performance Score:{' '}
            {Number(model.performanceScore) > 0 && parseFloat(model.performanceScore) > 0.0
              ? `${(parseFloat(model.performanceScore) * 100).toFixed(0)}%`
              : 'N/A'}
          </Typography>
        }
        {model.pricingInfo && (
          <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
            Usage Charge: ${model.pricingInfo.perInferenceUsageCharge.toFixed(2)}
          </Typography>
        )}
        {model.pricingInfo && (
          <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
            Price Info: {model.pricingInfo.servicePricingInfo}
          </Typography>
        )}
        {editEnabled ? <Button onClick={() => window.open(`/models/${model.modelId}/edit`,"_blank")}>Edit Model</Button> : <Button onClick={() => openClaimModal()}>Claim this Model</Button>}
      </Grid>
    </>
  );
};

export default DetailsSection;
